import { Newspaper } from "lucide-react";

const MediaCoverage = () => {
  return (
    <section id="media" data-testid="media-section" className="py-24 sm:py-32 bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="mb-16">
          <p className="text-sm uppercase tracking-[0.2em] font-semibold text-[#4A6670] mb-4 font-body" data-testid="media-overline">
            In The News
          </p>
          <h2 className="text-3xl sm:text-4xl tracking-tight font-medium text-slate-900 font-heading" data-testid="media-title">
            Media Coverage
          </h2>
        </div>

        <div className="flex flex-col items-center justify-center py-16 border border-dashed border-slate-300 rounded-sm bg-white">
          <Newspaper className="h-10 w-10 text-slate-300 mb-4" />
          <p className="text-base text-slate-400 font-body italic" data-testid="media-placeholder">
            Coming soon
          </p>
        </div>
      </div>
    </section>
  );
};

export default MediaCoverage;
